import * as R from 'ramda'
import netIncome from './netIncome'
import llBills from './llBills'
import moment from 'moment'

export default (transactions, owners, dateTill) => {
	transactions = R.filter(x => moment(dateTill) >= moment(x.dueDate))(transactions)
	let invoicesByPropertyID = R.pipe(R.values, R.filter(x => x.type == 'transaction/invoice'), R.groupBy(R.prop('propertyID')))(transactions)
	let billsByPropertyID = R.pipe(R.values, R.filter(x => x.type == 'transaction/bill'), R.groupBy(R.prop('propertyID')))(transactions)

	let currNetIncome = netIncome(invoicesByPropertyID, billsByPropertyID)
	let currLlBills = llBills(billsByPropertyID, owners)

	let balance = R.mergeWith(R.subtract, currNetIncome, currLlBills)

	return balance
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/balance.js